// https://webpack.js.org/guides/public-path/
/* eslint camelcase: 0, no-undef: 0 */
__webpack_public_path__ = window.ha.assetPath;
